export default __webpack_public_path__ + "static/1154-05bf062c58312caff37bd0e0f849dd3e.gif";